import React, { Component } from 'react';
import { Grid, Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { ConsultaPaices, ConsultaEstados, GuardarEstado, EditarEstado, verEstado, DeleteEstado } from "../../../funciones/EntidadesFuncion";

let statusBtn = 0;
let idEstado = null;

class Estados extends Component {
    state = {
        textInfo: <React.Fragment>Para agregar un nuevo estado indica primero el <strong>País</strong> a tu izquierda</React.Fragment>,
        valorPais: { value: '', label: '- Selecciona un País -' },
        paices: [{ value: '', label: ' - Cargando Espere - ' }],
        preloader:{ icon: "", text: "" },
        estadosDisp: [{ id: "", nombre: "" }],
        preloaderMess:{ icon: "", text: "" },
        boton1: { Icon:"fa fa-save", Title:"Guardar", disabled: ""},
        boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
        boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
        boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
        nombre:  { text:"", status: "" },
        cantErrores: "",
    }

    componentWillReceiveProps = (props) => {
        statusBtn = 0;
        this.setState({paices: props.paises})
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",
            }
        });
    };

    valorSelectPais = (valorPais) => {
        this.setState({
            valorPais,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Cargando"
            },
            textInfo: <React.Fragment>El país seleccionado es <strong>{valorPais.label}</strong></React.Fragment>,
        },() => {
            ConsultaEstados(valorPais.value, (resp) => {/* console.log(resp[1]) */
                this.setState({
                    estadosDisp: resp,
                    preloader:{ icon: "", text: "" },
                })
            })
        });
    }

    cancelar = () => {
        statusBtn = 0;
        this.setState({
            nombre:  { text:"", status: "" },
            cantErrores: "",
        })
    }

    editEstado = (id) => (e) => {
        idEstado = id;
        statusBtn = 1;
        this.setState ({
            preloaderMess:{ icon: "fa fa-spinner fa-spin", text: "" },
            boton2: { Icon:"fa fa-times", Title:"", disabled: "disabled"},
            boton3: { Icon:"fa fa-edit", Title:"", disabled: "disabled"},
            boton4: { Icon:"fa fa-trash", Title:"", disabled: "disabled"},
        }, () => {
            verEstado (id, (resp) => {
                this.setState(resp)
            })
        })
    }

    estadosDisp = () => { 
        let { estadosDisp } = this.state;
        if (estadosDisp === undefined || estadosDisp.length === 0) return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                No existen estados registrados para este país
            </div> 
        )
        if (estadosDisp[0].id === "") return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                Primero selecciona un <strong>País</strong> para mostrar los estados disponibles
            </div> 
        )

        let contenidoEstados = () => {
            return(
                estadosDisp.map(option => (
                    <tr onClick = {this.editEstado (option.id)} key={option.id} style={{cursor: "pointer"}} title = {`Haz Click para editar ${option.nombre}`}>
                        <td>{option.nombre}</td>
                    </tr>
                ))
            )
        }

        return (
            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                <Table striped hover>
                    <tbody>
                        {contenidoEstados()}
                    </tbody>
                </Table>
            </div>
        );
    }

    panel = () => {
        let { valorPais, paices, preloader } = this.state;

        return (
            <div className="custom-alert-info" style={{padding: 10}}>
                <Select
                    isSearchable ={true}
                    value={valorPais}
                    onChange={this.valorSelectPais}
                    options={paices}
                />
                <div align="center" style={{marginTop:5}}><i className={preloader.icon}></i>{preloader.text}</div>
                <div style={{ overflowY :"auto", height:"33vh",}}>{this.estadosDisp()}</div>
            </div>
        )
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let messOk = (mensaje) => {
            let { valorPais } = this.state;
            
            if (valorPais.value !== "") ConsultaEstados(valorPais.value, (resp) => {
                this.setState({
                    estadosDisp: resp,
                    preloader:{ icon: "", text: "" },
                })
            })

            this.setState({
                boton1:{
                    Icon:"fa fa-save",
                    Title:"Guardar",
                },
                boton3:{ Icon:"fa fa-edit" }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.cancelar()
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        messOk(mensaje[0]);
    }

    respuestaEditar = (resp) => {
        this.respuestaGuardar(resp)
    }

    botones = () => {
        let { valorPais, nombre, boton1, boton2, boton3, boton4 } = this.state;
        const campos = { nombre, valorPais }

        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary" disabled={boton1.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                        this.setState({
                            boton1:{ Icon: "fa fa-spinner fa-spin", Title: "Cargando" }
                        }, () => {
                            GuardarEstado (campos, (resp) => { this.respuestaGuardar(resp) })
                        })
                    }}><i className={boton1.Icon}></i> {boton1.Title}</button>
                )
            case 1:
                    
                let deleteC = (
                    <Popover title="Confirmacion" id="delpais">
                        <div>
                            ¿Desea realmente <strong>eliminar el estado <span className="text-info">{nombre.text}</span></strong> del Sistema?
                        </div>
                        <div align="right">
                            <button className="btn btn-danger" onClick = {

                                () => { DeleteEstado(idEstado, (mess) => {
                                    let data = JSON.parse(mess);
                                    if (data.status === "Error"){
                                        toast.error(data.mess,{autoClose: 4000});
                                        this.cancelar()
                                    }else{
                                        if (valorPais.value !== "") ConsultaEstados(valorPais.value, (resp) => {
                                            this.setState({
                                                estadosDisp: resp,
                                                preloader:{ icon: "", text: "" },
                                            })
                                        })
                                        
                                        toast.info("El estado fue eliminado exisosamente",{autoClose: 4000});
                                        this.cancelar()
                                    }
                                })}

                            } style={{borderWidth: 1}}><i className="fa fa-trash"></i> Eliminar</button>
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-primary"  disabled={boton2.disabled} onClick ={this.cancelar} title="Cancelar" style={{borderWidth: 1}}><i className={boton2.Icon}></i></button>
                        <button className="btn btn-warning"  disabled={boton3.disabled}
                        onClick={ (e) => {
                            this.setState({
                                boton3:{ Icon: "fa fa-spinner fa-spin" },
                            }, () => {
                                EditarEstado (idEstado, campos, (resp) => { this.respuestaEditar(resp) })
                            })
                        }}
                        title="Editar este Estado" style={{borderWidth: 1}}><i className={boton3.Icon}></i></button>
                        <OverlayTrigger trigger="click" placement="top" overlay={deleteC}>
                            <button className="btn btn-danger" disabled={boton4.disabled} title="Eliminar este Estado" style={{borderWidth: 1}}><i className={boton4.Icon}></i></button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                return (<div></div>)
        }
    }

    registro = () => {
        let { preloaderMess, textInfo, nombre, cantErrores } = this.state;

        let MainAyuda = (
                <Popover title="Registro de Estados" id="pais">
                    <div align="justify">
                        Para registrar estados primero selecciona el país al que pertenece, luego ingresa el nombre del estado y a continuación presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-save"></i> Guardar</button>
                    </div>
                    <div align="justify" className="custom-mt-10">
                        Para modificar un estado primero haz click en uno de los agregados a tu izquierda
                    </div>
                    <div align="justify" style={{fontSize:10}} className="custom-mt-10">
                        El botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-times"></i></button> Permite cancelar la selección
                    </div>
                    <div align="justify" style={{fontSize:10, marginTop: 5}}>
                        El botón <button className="btn btn-warning btn-xs" style={{borderWidth:1}}><i className="fa fa-edit"></i></button> Permite guardar los cambios
                    </div>
                    <div align="justify" style={{fontSize:10, marginTop: 5}}>
                        El botón <button className="btn btn-danger btn-xs" style={{borderWidth:1}}><i className="fa fa-trash"></i></button> Permite eliminar el pais seleccionado
                    </div>
                </Popover>
        )

        return (
            <React.Fragment>
                 <div className="custom-alert-success">
                    <Row>
                        <Col md={9} style={{paddingTop: 8, paddingLeft: 25}}>
                        <span><i className={preloaderMess.icon}></i>{preloaderMess.text}</span> {textInfo}
                        </Col>
                        <Col md={3} align="right">
                            <OverlayTrigger trigger="focus" placement="left" overlay={ MainAyuda }>
                                <button className="btn btn-relleno-success" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i></button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </div>
                <Row className="custom-mt-20">
                    <Col md={8}>
                        <div className={nombre.status}>
                            <input type="text" value={nombre.text} onChange={this.cambiaValor("nombre")} className="form-control" placeholder="* Nombre del Estado"/>
                        </div>
                    </Col>
                    <Col md={4} align="right">
                        {this.botones()}
                    </Col>
                    <Col md ={12}><div className="text-danger">{ cantErrores }</div></Col>
                </Row>
            </React.Fragment>
        )
    }

    render() { 
        return (
            <Grid fluid className="custom-mt-20">
                <Row>
                    <Col md={4}>{this.panel()}</Col>
                    <Col md={8}>{this.registro()}</Col>
                </Row>
            </Grid>
        );
    }
}
 
export default Estados;


// WEBPACK FOOTER //
// ./src/views/Registros/EstadosContent/Estados.jsx